/**
 * Alpine.js component for bookmark toggle buttons.
 *
 * Uses the /app/bookmarks/toggle AJAX endpoint (POST with CSRF token).
 * Provides loading spinner and active/inactive state management.
 *
 * Usage in Twig:
 *   <button x-data="bookmarkButton(false, '123')" @click="toggle()" ...>
 *       <i class="fas fa-spinner fa-spin" x-show="loading"></i>
 *       <i :class="active ? 'fas fa-bookmark' : 'far fa-bookmark'" x-show="!loading"></i>
 *   </button>
 */
export function bookmarkButton(isBookmarked = false, userId = '') {
    return {
        loading: false,
        active: isBookmarked,
        userId: String(userId),

        async toggle() {
            if (this.loading) return;

            this.loading = true;
            try {
                const csrfToken = document.querySelector('meta[name="csrf_token"]')?.content
                    || document.querySelector('input[name="csrf_token"]')?.value
                    || '';

                const response = await fetch('/app/bookmarks/toggle', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: 'user_id=' + encodeURIComponent(this.userId) + '&csrf_token=' + encodeURIComponent(csrfToken)
                });

                const data = await response.json();
                if (data.success) {
                    this.active = data.is_bookmarked;
                } else {
                    this.showFailure(data.error_msg);
                }
            } catch (e) {
                console.error('Bookmark toggle error:', e);
                this.showFailure();
            } finally {
                this.loading = false;
            }
        },

        // The server message names the cause, for example the bookmark limit.
        showFailure(serverMessage) {
            if (typeof serverMessage === 'string' && serverMessage) {
                window.showError?.(serverMessage);
                return;
            }
            const message = window.tOr('common.alert_bookmark_error', '');
            if (message) window.showError?.(message);
        }
    };
}
